import { render, staticRenderFns } from "./entity-details.vue?vue&type=template&id=24418352&scoped=true"
import script from "./entity-details.vue?vue&type=script&lang=js"
export * from "./entity-details.vue?vue&type=script&lang=js"
import style0 from "./entity-details.vue?vue&type=style&index=0&id=24418352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24418352",
  null
  
)

export default component.exports